module.exports = __webpack_public_path__ + "assets/img/00000.cef74c7d.png";